<div class="container-fluid main-card">
    <div class="row">
        <div class="col-12">
            <h1>
                Mon compte
                <span>Gérez mes informations personnelles</span>
            </h1>
        </div>
    </div>
    <div class="col-lg-12">
        <div class="row">
            <div class="colWidget col-lg-6">
                <div class="row">
                    <div class="col-12">
                        <div class="card block isMinimizable">
                            <div class="card-header">
                                <div class="card-title">
                                    <i class="fa fa-angle-up"></i>
                                    <h2>Mes informations de facturation</h2>
                                </div>
                            </div>
                            <div class="card-body col-12">
                                <form [formGroup]="accountForm">
                                    <div class="card-text row">
                                        <div class="col-lg-12">
                                            <mat-form-field>
                                                <mat-label>Email</mat-label>
                                                <input matInput formControlName="email" class="text">
                                                <mat-error
                                                    *ngIf="accountForm.get('email').invalid">{{ formService.getErrorMessage(accountForm.get('email')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-6">
                                            <mat-form-field>
                                                <mat-label>Prénom</mat-label>
                                                <input matInput formControlName="firstName"
                                                       class="text">
                                                <mat-error
                                                    *ngIf="accountForm.get('firstName').invalid">{{ formService.getErrorMessage(accountForm.get('firstName')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-6">
                                            <mat-form-field>
                                                <mat-label>Nom</mat-label>
                                                <input matInput formControlName="lastName" class="text">
                                                <mat-error
                                                    *ngIf="accountForm.get('lastName').invalid">{{ formService.getErrorMessage(accountForm.get('lastName')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-6">
                                            <mat-form-field>
                                                <mat-label>Société (facultatif)</mat-label>
                                                <input matInput formControlName="company_name"
                                                       class="text">
                                                <mat-error
                                                    *ngIf="accountForm.get('company_name').invalid">{{ formService.getErrorMessage(accountForm.get('company_name')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-6">
                                            <mat-form-field>
                                                <mat-label>Mobile</mat-label>
                                                <input matInput formControlName="mobile" class="text">
                                                <mat-error
                                                    *ngIf="accountForm.get('mobile').invalid">{{ formService.getErrorMessage(accountForm.get('mobile')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-12">
                                            <mat-form-field class="lines-2">
                                                <mat-label>Adresse</mat-label>
                                                <textarea formControlName="adress"
                                                          matInput
                                                          placeholder=""></textarea>
                                                <mat-error
                                                    *ngIf="accountForm.get('adress').invalid">{{ formService.getErrorMessage(accountForm.get('adress')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-6">
                                            <mat-form-field>
                                                <mat-label>Code postal</mat-label>
                                                <input formControlName="zip_code" matInput class="text">
                                                <mat-error
                                                    *ngIf="accountForm.get('zip_code').invalid">{{ formService.getErrorMessage(accountForm.get('zip_code')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-6">
                                            <mat-form-field>
                                                <mat-label>Ville</mat-label>
                                                <input formControlName="city" matInput class="text">
                                                <mat-error
                                                    *ngIf="accountForm.get('city').invalid">{{ formService.getErrorMessage(accountForm.get('city')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-lg-12">
                                            <mat-checkbox formControlName="mailing">
                                                Je souhaite être informé par mail des nouveautés et des
                                                conseils LyBox
                                            </mat-checkbox>
                                            <br/>
                                            <br/>
                                        </div>

                                    </div>
                                </form>
                                <div class="mb-3" id="wonderpush-subscription-switch"
                                     data-color-on="#0075DB"
                                     data-sentence="Activer les notifications sur cet appareil : "></div>
<!--                                <a href="#" onclick="WonderPush.subscribeToNotifications(event); return false;">Activer les notifications</a>-->
<!--                                <a href="#" onclick="console.log(WonderPush.showSubscriptionDialog()); return false;">Activer les notifications</a>-->
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="card block isMinimizable">
                            <div class="card-header">
                                <div class="card-title">
                                    <i class="fa fa-angle-up"></i>
                                    <h2>Mot de passe</h2>
                                </div>
                            </div>
                            <div class="card-body col-12">
                                <form [formGroup]="passwordForm" (ngSubmit)="passwordUpdate()">
                                    <div class="card-text row">
                                        <div class="col-12">
                                            <mat-form-field>
                                                <mat-label>Mot de passe actuel</mat-label>
                                                <input matInput formControlName="old_password"
                                                       [type]="hide ? 'password' : 'text'" class="text">
                                                <p mat-icon-button matSuffix (click)="hide = !hide"
                                                   [attr.aria-label]="'Hide password'"
                                                   [attr.aria-pressed]="hide">
                                                    <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                                                </p>
                                                <mat-error
                                                    *ngIf="passwordForm.get('old_password').invalid">{{ formService.getErrorMessage(passwordForm.get('old_password')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-lg-6">
                                            <mat-form-field>
                                                <mat-label>Nouveau mot de passe</mat-label>
                                                <input matInput formControlName="new_password"
                                                       [type]="hide ? 'password' : 'text'" class="text">
                                                <p mat-icon-button matSuffix (click)="hide = !hide"
                                                   [attr.aria-label]="'Hide password'"
                                                   [attr.aria-pressed]="hide">
                                                    <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                                                </p>
                                                <mat-error
                                                    *ngIf="passwordForm.get('new_password').invalid">{{ formService.getErrorMessage(passwordForm.get('new_password')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-6">
                                            <mat-form-field>
                                                <mat-label>Nouveau mot de passe</mat-label>
                                                <input matInput formControlName="new_password2"
                                                       [type]="hide ? 'password' : 'text'" class="text">
                                                <p mat-icon-button matSuffix (click)="hide = !hide"
                                                   [attr.aria-label]="'Hide password'"
                                                   [attr.aria-pressed]="hide">
                                                    <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                                                </p>
                                                <mat-error
                                                    *ngIf="passwordForm.get('new_password2').invalid">{{ formService.getErrorMessage(passwordForm.get('new_password2')) }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-12">
                                            <button class="btn btn-primary"
                                                    [disabled]="passwordForm.invalid">
                                                Enregistrer
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" *ngIf="user.pro_plan == ''">
                        <div class="card block isMinimizable minimize">
                            <div class="card-header">
                                <div class="card-title">
                                    <i class="fa fa-angle-up"></i>
                                    <h2>Suppression de compte</h2>
                                </div>
                            </div>
                            <div class="card-body col-12">
                                <p>
                                    Vous pouvez supprimer votre compte LyBox à tout moment. Cette action est
                                    irréversible et entrainera la perte de toutes vos données présentes sur LyBox
                                    (favoris, recherches, simulations ...)
                                </p>
                                <p class="text-center">
                                    <a routerLink="/app/user/plan" class="fs-4" *ngIf="user.plan != '' && user.plan != 'trial' && user.plan != 'trial_plus' && (user.subscription.cancel_date == '01/01/0001' || user.subscription.cancel_date == '01/01/1970')">
                                        Cliquez ici pour résilier votre abonnement avant de pouvoir supprimer votre compte.
                                    </a>
                                    <button *ngIf="(user.plan == '' && user.subscription.cancel_date != '01/01/0001' && user.subscription.cancel_date != '01/01/1970') || user.plan == 'trial' || user.plan == 'trial_plus' || user.plan == ''" type="button" (click)="deleteAccount()" class="btn btn-danger float-none">
                                        Supprimer mon compte
                                    </button>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="colWidget col-lg-6">
                <div class="row">
                    <div class="col-12" *ngIf="user.pro_plan == '' || user.pro_plan == 'lybox'">
                        <div class="card block isMinimizable">
                            <div class="card-header">
                                <div class="card-title">
                                    <i class="fa fa-angle-up"></i>
                                    <h2 *ngIf="!isInfluenceur">
                                        Parrainage
                                    </h2>
                                    <h2 *ngIf="isInfluenceur">
                                        Affiliation
                                    </h2>
                                </div>
                            </div>
                            <div class="card-body col-12">
                                <form [formGroup]="accountForm">
                                    <div class="card-text row">
                                        <div class="col-12">
                                            <h3 class="mb-3"
                                                *ngIf="!filleulLoading && !isInfluenceur">
                                                Mes filleuls
                                            </h3>
                                            <h3 class="mb-3"
                                                *ngIf="!filleulLoading && isInfluenceur && affiliationActive">
                                                Mes affiliés
                                            </h3>

                                            <div class="infoCb mb-4" *ngIf="!filleulLoading && !isInfluenceur">
                                                Partagez LyBox avec vos amis offrez leur un mois d'abonnement et recevez
                                                vous aussi un
                                                mois gratuit.<br/>
                                                Pour cela, envoyez votre lien ou votre code de parrainage à votre
                                                filleul pour qu’il
                                                s’inscrive à LyBox : <br/><br/>
                                                Code parrainage : <b>{{ user.code_filleul }}</b> ou partager votre
                                                lien :
                                                <a href="https://www.lybox.fr/app/register?parrain={{ user.code_filleul }}">https://www.lybox.fr/app/register?parrain={{ user.code_filleul }}</a>
                                            </div>

                                            <div class="infoCb mb-4" *ngIf="!filleulLoading && isInfluenceur && affiliationActive">
                                                Partager votre lien :
                                                <a href="https://www.lybox.fr/app/partner/{{ user.code_filleul | lowercase }}">
                                                    https://www.lybox.fr/app/partner/{{ user.code_filleul | lowercase }}
                                                </a> / <a
                                                href="https://www.lybox.fr/app/search/result?partner={{ user.code_filleul | lowercase }}">https://www.lybox.fr/app/search/result?partner={{ user.code_filleul | lowercase }}</a>
                                                ou votre code d'affiliation : <b>{{ user.code_filleul }}</b><br/>
                                                <br/>
                                                <ng-container *ngIf="affiliationActive">
                                                    <b>{{ affiliationRate }}%</b> des revenus HT générés par vos affiliés
                                                    vous seront reversés tant que l’affilié reste client.
                                                </ng-container>
                                                <br/>
                                                Nous avons mis à disposition un kit média avec des exemples de vidéos, de mail, des images de marque pour vous aider à promouvoir LyBox facilement :
                                                <a href="https://laced-mammal-6a4.notion.site/Ressources-affili-s-19ec6df1fe5280df85bfd14b905b5293">➡️ Accéder au kit média</a><br/>
                                                <br/>
                                                Voir les <a target="_blank" href="https://www.lybox.fr/affiliation">Conditions
                                                générales du programme Ambassadeur</a>
                                            </div>

                                            <!-- Programme d'affiliation désactivé -->
                                            <div class="alert alert-warning" *ngIf="!filleulLoading && isInfluenceur && !affiliationActive">
                                                <b>Votre programme d'affiliation est actuellement désactivé.</b>&nbsp;
                                                <a href="mailto:contact@lybox.fr">Contactez-nous</a> pour le réactiver.
                                            </div>

                                            <!-- Loader pendant le chargement de l'affiliation -->
                                            <div class="text-center py-4" *ngIf="filleulLoading">
                                                <mat-progress-spinner mode="indeterminate" diameter="36" class="mx-auto"></mat-progress-spinner>
                                            </div>

                                            <!-- Filleuls parrainés (utilisateur non influenceur) -->
                                            <ng-container *ngIf="!filleulLoading && !isInfluenceur">
                                                <p class="text-center" *ngIf="filleuls.length == 0">
                                                    Aucun filleul
                                                </p>
                                                <ul class="filleuls" *ngIf="filleuls.length > 0">
                                                    <li *ngFor="let filleul of filleuls">
                                                        <button *ngIf="filleul.valid_filleul"
                                                                class="btn btn-sm btn-success">Validé
                                                        </button>
                                                        <button *ngIf="!filleul.valid_filleul"
                                                                class="btn btn-sm btn-outline">En attente
                                                        </button>
                                                        {{ filleul.firstname }} {{ filleul.lastname }}
                                                    </li>
                                                </ul>
                                            </ng-container>

                                            <!-- Tableau de bord d'affiliation (utilisateur influenceur actif) -->
                                            <ng-container *ngIf="!filleulLoading && isInfluenceur && affiliationActive">
                                                <!-- KPI -->
                                                <div class="row kpi">
                                                    <div class="col-6 col-lg-3">
                                                        <div class="card kpi-blue">
                                                            <div class="card-body kpi-card">
                                                                <h5 class="card-title">Total gagné</h5>
                                                                <p class="card-value">{{ affiliationTotal / 100 | number: '1.2-2' }} <span class="fs-7"> €</span></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-6 col-lg-3">
                                                        <div class="card kpi-orange">
                                                            <div class="card-body kpi-card">
                                                                <h5 class="card-title">Restant dû HT</h5>
                                                                <p class="card-value">{{ affiliationRemaining / 100 | number: '1.2-2' }} <span class="fs-7"> €</span></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-6 col-lg-3">
                                                        <div class="card kpi-green">
                                                            <div class="card-body kpi-card">
                                                                <h5 class="card-title">Affiliés actifs</h5>
                                                                <p class="card-value">{{ affiliationActiveUsers }}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-6 col-lg-3">
                                                        <div class="card kpi-purple">
                                                            <div class="card-body kpi-card">
                                                                <h5 class="card-title">Inscrits sur 30 j</h5>
                                                                <p class="card-value">{{ affiliationRegisteredLast30 }}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Demande de retrait -->
                                                <div class="mb-4">
                                                    <button type="button" class="btn" [disabled]="!canWithdraw"
                                                            (click)="openInvoiceDialog()">
                                                        <i class="fa cfa cfa-pdf" aria-hidden="true"></i>
                                                        Déposer ma facture (retirer le solde)
                                                    </button>
                                                    <span class="fs-4 ms-2 d-block d-md-inline mt-2 mt-md-0" *ngIf="!canWithdraw">
                                                        Retrait possible à partir de <b>200 € HT</b> de solde restant dû.
                                                    </span>
                                                </div>

                                                <!-- Commissions depuis le dernier virement -->
                                                <h3 class="mb-3">Commissions depuis votre dernier virement</h3>
                                                <p class="text-center" *ngIf="displayedPaiements.length == 0">
                                                    Aucune commission depuis votre dernier virement.
                                                </p>
                                                <div class="table-responsive" *ngIf="displayedPaiements.length > 0">
                                                    <table class="table table-striped affiliation-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Date</th>
                                                                <th>Filleul</th>
                                                                <th>Plan</th>
                                                                <th class="text-end">Montant</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let p of displayedPaiements">
                                                                <td>{{ p.created_at | date:'dd/MM/yyyy' }}</td>
                                                                <td>{{ p.firstname }} {{ p.lastname }}</td>
                                                                <td>
                                                                    <span *ngIf="p.type === 'paiement'" class="text-muted">Virement</span>
                                                                    <span *ngIf="p.type === 'remboursement'" class="text-danger">Remboursement</span>
                                                                    <span *ngIf="p.type === 'litige'" class="text-danger">Litige</span>
                                                                    <span *ngIf="p.type === 'nouvel_abonnement' || p.type === 'renouvellement'">{{ p.plan || '—' }}</span>
                                                                </td>
                                                                <td class="text-end"
                                                                    [ngClass]="{'text-success': p.type === 'paiement', 'text-danger': p.type !== 'paiement' && p.amount < 0}">
                                                                    <b>{{ p.amount / 100 | number: '1.2-2' }} €</b>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="text-center mt-2" *ngIf="hasMorePaiements">
                                                    <a class="btn btn-outline btn-sm" (click)="showAllPaiements = true">
                                                        Afficher tout l'historique
                                                    </a>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="card block isMinimizable minimize">
                            <div class="card-header">
                                <div class="card-title">
                                    <i class="fa fa-angle-up"></i>
                                    <h2>Historique de facturation</h2>
                                </div>
                            </div>
                            <div class="card-body col-12">
                                <div class="card-text row">
                                    <p class="text-center" *ngIf="invoices.length == 0">Aucune facture</p>
                                    <ul class="invoices">
                                        <li *ngFor="let invoice of invoices">
                                            <a class="pdf btn btn-outline-primary" *ngIf="invoice.invoice_pdf" (click)="openInvoice(invoice);">
                                                <i class="fa cfa cfa-pdf"></i> Télecharger
                                            </a>
                                            <p class="date">
                                                {{ invoice.date }}
                                            </p>
                                            <p class="amount">
                                                {{ invoice.amount / 100 | number: '1.2-2' }} €
                                            </p>
                                        </li>
                                    </ul>
                                    <div class="col-12">
                                        <h2 class="mb-3" *ngIf="user.payment_method.type != ''">Moyen de paiement</h2>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <b class="fs-4" *ngIf="user.payment_method.type == 'sepa_debit'">
                                            Prélèvement bancaire<br/>
                                        </b>
                                        <b class="fs-4" *ngIf="user.payment_method.type == 'card'">
                                            {{ user.payment_method.type_detail | titlecase }} {{ user.payment_method.last_4 }}
                                            <br/>
                                            Expire en {{ user.payment_method.exp_month }}
                                            /{{ user.payment_method.exp_year }}
                                        </b>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <button (click)="updateCB()" class="btn btn-primary"
                                                *ngIf="user.payment_method.type != ''">
                                            Modifier mon moyen de paiement
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
